module.exports = __webpack_public_path__ + "static/media/asite.15518da6.jpg";